import {
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Box,
} from '@chakra-ui/react';

import SectionCard from '../../components/SectionCard';
import type { Location } from 'api';

interface LocationCardProps {
  location: Location;
}

const LocationCard = ({ location }: LocationCardProps) => {
  return (
    <SectionCard title="Location">
      <SimpleGrid columns={{ base: 1, md: 12 }} spacing={2}>
        <Box gridColumn={{ base: 'span 1', md: 'span 6' }}>
          <FormControl>
            <FormLabel fontSize="sm">Address</FormLabel>
            <Input
              variant="main"
              size="sm"
              value={location.address || ''}
              isReadOnly
              bg="gray.50"
              cursor="default"
            />
          </FormControl>
        </Box>

        <Box gridColumn={{ base: 'span 1', md: 'span 3' }}>
          <FormControl>
            <FormLabel fontSize="sm">City</FormLabel>
            <Input
              variant="main"
              size="sm"
              value={location.city || ''}
              isReadOnly
              bg="gray.50"
              cursor="default"
            />
          </FormControl>
        </Box>

        <Box gridColumn={{ base: 'span 1', md: 'span 3' }}>
          <FormControl>
            <FormLabel fontSize="sm" whiteSpace="nowrap">
              Postal Code
            </FormLabel>
            <Input
              variant="main"
              size="sm"
              value={location.postal_code || ''}
              isReadOnly
              bg="gray.50"
              cursor="default"
            />
          </FormControl>
        </Box>
      </SimpleGrid>
    </SectionCard>
  );
};

export default LocationCard;
